export function stringDateToDate(dateStr: string): Date {
    const [year, month, date] = (dateStr || '').split('-')
    return new Date(parseInt(year), parseInt(month) - 1, parseInt(date), 12, 0, 0, 0);
}